import React from "react";
import { Container } from "reactstrap";
import { Link } from "react-router-dom";

const BreadcrumbsArticle = ({ items }) => {
    return (
        <nav aria-label="Breadcrumb" className="article-breadcrumbs">
            <Container>
                <ol>
                    {items.map((item, index) => (
                        <li key={index}>
                            {item.href ? (
                                <Link to={item.href}>{item.label}</Link>
                            ) : (
                                <span>{item.label}</span>
                            )}
                        </li>
                    ))}
                </ol>
            </Container>
        </nav>
    );
};

export default BreadcrumbsArticle;